export default {"src":"/_next/static/media/health_plan.0379cf32.svg","height":314,"width":1044,"blurWidth":0,"blurHeight":0};